// extracted by mini-css-extract-plugin
export var editButton = "_mo-0";